import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {SegmentosOcupaciones} from '../_models/segmentos-ocupaciones';

@Injectable({
  providedIn: 'root'
})
export class SegmentosOcupacionesService {
  private rutaServicio = AppSettings.rutServiciosAPL + '/api/segmentosOcupaciones/';

  constructor( private httpClient: HttpClient, private autenticacionService: AutenticacionService) { }


  listado(): Observable<SegmentosOcupaciones[]> {
    return this.httpClient.get( this.rutaServicio ).pipe( map( res => res as SegmentosOcupaciones[] ) );
  }

  SegmentoOcupaciones( idSegmento: string ): Observable<SegmentosOcupaciones> {
    return this.httpClient.get( this.rutaServicio + idSegmento ).pipe( map( res => res as SegmentosOcupaciones ) );
  }

  listaxIdSegmento( idSegmento: string ): Observable<SegmentosOcupaciones[]> {
    return this.httpClient.get( this.rutaServicio + 'segmento/' + idSegmento ).pipe( map( res => res as SegmentosOcupaciones[] ) );
  }

  crear( segmentoOcupacion: SegmentosOcupaciones ): Observable<SegmentosOcupaciones> {
    segmentoOcupacion.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutaServicio, segmentoOcupacion ).pipe( map( res => res as SegmentosOcupaciones ) );
  }

  actualizar( segmento: SegmentosOcupaciones ): Observable<any> {
    return this.httpClient.put( this.rutaServicio, segmento ).pipe( map( res => res ) );
  }

  bulk( segmentoOcupaciones: SegmentosOcupaciones[] ): Observable<SegmentosOcupaciones[]> {
    segmentoOcupaciones.map( sa => {
      sa.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient.post( this.rutaServicio + 'bulk', segmentoOcupaciones ).pipe( map( res => res as SegmentosOcupaciones[] ) );
  }
}
